import React from "react";
import HeaderBottom from "../assets/header-bottom-shap.png"
import { useTranslation } from 'react-i18next'

const ContactUs = () => {
    const { t } = useTranslation();
  return (
      <main className="main position-relative">
        <div className="bottom-main-shap position-absolute top-0">
          <img src={HeaderBottom} alt="" />
        </div>
        <div className="contact-us-sec pt-5 position-relative z-1 mb-5">
          <div className="container">
            <div className="trip-right-sec p-0">
              <div className="com-contact-box credential-sec p-0 d-flex flex-wrap">
                
                {/* Left Contact Info */}
                <div className="left-contact">
                  <div className="top-contact mb-4">
                    <h4 className="mb-2">{t("contactInformation")}</h4>
                    <p> {t("saySomething")} </p>
                  </div>
                  <div className="bottom-contact">
                    <ul className="p-0 m-0 list-unstyled">
                      <li>
                        <a href="#" className="d-flex align-items-center gap-3">
                          <span className="icons">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                              xmlns="http://www.w3.org/2000/svg"><path d="M20.0002 10.999H22.0002C22.0002 5.869 18.1272 2 12.9902 2V4C17.0522 4 20.0002 6.943 20.0002 10.999Z" fill="black" /><path	d="M13.0003 7.99999C15.1033 7.99999 16.0003 8.89699 16.0003 11H18.0003C18.0003 7.77499 16.2253 5.99999 13.0003 5.99999V7.99999ZM16.4223 13.443C16.2301 13.2683 15.9776 13.1752 15.7181 13.1832C15.4585 13.1912 15.2123 13.2998 15.0313 13.486L12.6383 15.947C12.0623 15.837 10.9043 15.476 9.71228 14.287C8.52028 13.094 8.15928 11.933 8.05228 11.361L10.5113 8.96699C10.6977 8.78612 10.8064 8.53982 10.8144 8.2802C10.8225 8.02059 10.7292 7.76804 10.5543 7.57599L6.85928 3.51299C6.68432 3.32035 6.44116 3.2035 6.18143 3.18725C5.92171 3.17101 5.66588 3.25665 5.46828 3.42599L3.29828 5.28699C3.12539 5.46051 3.0222 5.69145 3.00828 5.93599C2.99328 6.18599 2.70728 12.108 7.29928 16.702C11.3053 20.707 16.3233 21 17.7053 21C17.9073 21 18.0313 20.994 18.0643 20.992C18.3088 20.9783 18.5396 20.8747 18.7123 20.701L20.5723 18.53C20.7417 18.3325 20.8276 18.0768 20.8115 17.817C20.7954 17.5573 20.6788 17.3141 20.4863 17.139L16.4223 13.443Z" fill="black" /></svg>
                          </span>
                          <span className="text">+1012 3456 789</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex align-items-center gap-3">
                          <span className="icons">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 4H2V20H22V4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="black" /></svg>
                          </span>
                          <span className="text">demo@gmail.com</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex gap-3">
                          <span className="icons">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1.5C9.81276 1.50258 7.71584 2.3726 6.16923 3.91922C4.62261 5.46584 3.75259 7.56276 3.75001 9.75C3.74739 11.5374 4.33124 13.2763 5.41201 14.7C5.41201 14.7 5.63701 14.9963 5.67376 15.039L12 22.5L18.3293 15.0353C18.3623 14.9955 18.588 14.7 18.588 14.7L18.5888 14.6978C19.669 13.2747 20.2526 11.5366 20.25 9.75C20.2474 7.56276 19.3774 5.46584 17.8308 3.91922C16.2842 2.3726 14.1873 1.50258 12 1.5ZM12 12.75C11.4067 12.75 10.8266 12.5741 10.3333 12.2444C9.83995 11.9148 9.45543 11.4462 9.22837 10.8981C9.00131 10.3499 8.9419 9.74667 9.05765 9.16473C9.17341 8.58279 9.45913 8.04824 9.87869 7.62868C10.2982 7.20912 10.8328 6.9234 11.4147 6.80764C11.9967 6.69189 12.5999 6.7513 13.1481 6.97836C13.6962 7.20542 14.1648 7.58994 14.4944 8.08329C14.8241 8.57664 15 9.15666 15 9.75C14.999 10.5453 14.6826 11.3078 14.1202 11.8702C13.5578 12.4326 12.7954 12.749 12 12.75Z" fill="black" /></svg>
                          </span>
                          <span className="text">
                            {t("address")}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Right Contact Form */}
                <div className="right-contcat">
                  <div className="form-sec">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="firstName"
                            placeholder="First Name"
                          />
                          <label htmlFor="firstName"> {t("First Name")} </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="lastName"
                            placeholder="Last Name"
                          />
                          <label htmlFor="lastName"> {t("Last Name")} </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="name@example.com"
                          />
                          <label htmlFor="email"> {t("Email")} </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="phone"
                            placeholder="Phone Number"
                          />
                          <label htmlFor="phone"> {t("Phone Number")} </label>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label htmlFor="message"> {t("Message")} </label>
                          <textarea
                            className="form-control"
                            id="message"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-md-12 d-flex justify-content-end">
                        <button type="button" className="btn btn-primary">
                          {t("Send")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </main>
  );
};

export default ContactUs;
